import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const BackdropDriftScaleListItem = (props) => {
    const { scale, updateBackgroundSettings } = props;

    const onScaleChange = (value) => {
        updateBackgroundSettings({ drift: { scale: value } });
    };

    return (
        <SliderListItem
            title='Size'
            displayMultiplier={50}
            value={scale}
            min={0}
            max={100}
            step={1}
            onValueChange={onScaleChange}
            toolTip='How much the background size increases during loud audio.'
        />
    );
};

const mapStateToProps = (state) => {
    const { scale } = state.createPreview.present.videoSettings.background.drift;
    return { scale };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropDriftScaleListItem);
